import Autocomplete from "@mui/material/Autocomplete";
import EditorVisualTextField from "developer/edit/components/EditorVisualTextField";

type TypeFieldProps = {
  name: string;
  value: any;
  onChange: (value: any) => void;
  disabled?: boolean;
};

const OPTIONS: string[] = [
  "text",
  // "multilineText",
  "number",
  "date",
  "datetime",
  "url",
  "email",
  "options",
  "boolean",
  "tristate",
  "attachment",
];

const TypeField = (props: TypeFieldProps) => {
  // Deprecated the "select" field type, and replaced it with the "options"
  // field type in the visual editor. The "select" option has been removed.
  const value = props.value === "select" ? "options" : props.value;

  return (
    <Autocomplete
      id="type"
      size="small"
      onChange={(event, newValue) => {
        props.onChange(newValue);
      }}
      value={value}
      options={OPTIONS}
      autoHighlight
      fullWidth
      disabled={props.disabled}
      disableClearable
      renderInput={(params) => (
        <EditorVisualTextField {...params} name={props.name} label="Type" />
      )}
    />
  );
};

export default TypeField;
